import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { PagingParams } from '@abaco/web-common/src/Paging';

export default class PrincesWidgetsAPI {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getBlocksData(SCLeaderPkCuaa: number, paging: PagingParams, campaign: number, filters: any, farmPkCuaa: number | null, crop?: any) {
        
        const params: any = {
            count: paging.count,
            offset: paging.offset,
            filter: [],
        }
        Object.keys(filters)?.forEach((filter: any) => {
            if (filters[filter].length > 0 || filters[filter] > 0) {
                params.filter.push(`${filter} ${this.getComparator(filter)} ${filters[filter]}`)
            }
        })

        if (farmPkCuaa) params.filter.push(`subject_id eq ${farmPkCuaa}`);
        if (crop) params.filter.push(`crop_code eq ${crop}`);

        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/dashboard/melavi/scs/${SCLeaderPkCuaa}/campaigns/${campaign}/plantings`, { params });
        return res.data
    }

    public async getFilteredCounters(SCLeaderPkCuaa: number, campaign: number, filters: any, farmPkCuaa: number | null, crop?: any) {
        const params: any = {
            filter: [],
        }
        Object.keys(filters)?.forEach((filter: any) => {
            if (filters[filter].length > 0 || filters[filter] > 0)
                params.filter.push(`${filter} ${this.getComparator(filter)} ${filters[filter]}`)
        })

        if (farmPkCuaa) params.filter.push(`subject_id eq ${farmPkCuaa}`);
        if (crop) params.filter.push(`crop_code eq ${crop}`);

        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/dashboard/melavi/scs/${SCLeaderPkCuaa}/campaigns/${campaign}/plantings/counters`, { params });
        return res.data
    }

    getComparator(k: string) {
        const numberBlackList = ["plot_area", "block_area", "sub_block_area", "sub_block_interrow_distance", "sub_block_planting_distance", "sub_block_planting_year", "block_num_plants"];
        return numberBlackList.includes(k)
            ? "eq"
            : "like"
    }

    public async getCSV(SCLeaderPkCuaa: number, campaign: number, filters: any, farmPkCuaa: number | null) {
        const params: any = {
            filter: [],
        }

        Object.keys(filters)?.forEach((filter: any) => {
            if (filters[filter].length > 0 || filters[filter] > 0) {
                params.filter.push(`${filter} ${this.getComparator(filter)} ${filters[filter]}`)
            }
        })

        if (farmPkCuaa) params.filter.push(`subject_id eq ${farmPkCuaa}`);
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/dashboard/melavi/scs/${SCLeaderPkCuaa}/campaigns/${campaign}/plantings/csv`, { params });
        return res.data
    }

}
